import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export let COUNTRY = "CI";
export const setCountry = (c) => { if (c) COUNTRY = c; };

export const fmt = (n, cur = "FCFA") =>
  `${Number(n || 0).toLocaleString("fr-FR")} ${cur}`;

export const EXP_STATUS = {
  brouillon: ["Brouillon", "bg-slate-500/15 text-slate-400"],
  soumise: ["Soumise", "bg-blue-500/15 text-blue-400"],
  en_validation: ["En validation", "bg-amber-500/15 text-amber-400"],
  approuvee: ["Approuvée", "bg-emerald-500/15 text-emerald-400"],
  refusee: ["Refusée", "bg-rose-500/15 text-rose-400"],
  a_payer: ["À payer", "bg-cyan-500/15 text-cyan-400"],
  partiellement_payee: ["Part. payée", "bg-violet-500/15 text-violet-400"],
  payee: ["Payée", "bg-emerald-600/20 text-emerald-300"],
  annulee: ["Annulée", "bg-slate-600/20 text-slate-400"],
  archivee: ["Archivée", "bg-slate-600/20 text-slate-400"],
  demandee: ["Demandée", "bg-blue-500/15 text-blue-400"],
  versee: ["Versée", "bg-cyan-500/15 text-cyan-400"],
  justifiee: ["Justifiée", "bg-violet-500/15 text-violet-400"],
  soldee: ["Soldée", "bg-emerald-600/20 text-emerald-300"],
  enregistree: ["Enregistrée", "bg-blue-500/15 text-blue-400"],
  convertie: ["Convertie", "bg-emerald-600/20 text-emerald-300"],
};

export function Status({ s }) {
  const [label, cls] = EXP_STATUS[s] || [s, "bg-slate-500/15 text-slate-400"];
  return <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${cls}`}>{label}</span>;
}

export function useList(path, deps = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(() => {
    setLoading(true);
    api.get(path).then(({ data }) => setData(data)).catch(() => {}).finally(() => setLoading(false));
  }, [path]); // eslint-disable-line
  useEffect(() => { reload(); }, deps); // eslint-disable-line
  return { data, loading, reload };
}

export function Field({ label, children, full }) {
  return <div className={full ? "sm:col-span-2" : ""}><label className="text-sm text-slate-300">{label}</label><div className="mt-1.5">{children}</div></div>;
}

export const inputCls = "w-full px-3 py-2 rounded-lg bg-[#0B0F17] border border-[#1E293B] text-white text-sm focus:border-[#3B82F6] focus:outline-none";
